import pino, { Logger } from "pino";

const logger: Logger =
  process.env.ENVIRONMENT === "local"
    ? // Pretty print in local
      pino({
        transport: {
          target: "pino-pretty",
          options: {
            colorize: true,
          },
        },
        level: process.env.LOG_LEVEL || "debug",
      })
    : // JSON everywhere else
      pino({ level: process.env.LOG_LEVEL || "info" });

export default logger;
